import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HomeIpApi, HomeIpApiImpl } from './apis/home-ip-api';
import { PlaybookRegistry } from './services/playbook-registry';
import { PlaybookRegistryImpl } from './services/impls/playbook-registry';
import { IpProfileExternalServiceImpl } from './services/impls/ip-profile-external-service';
import { IpProfileExternalService } from './services/ip-profile-external-service';
import { MonitorAgentService } from './services/monitor-agent-service';
import { MonitorAgentServiceImpl } from './services/impls/monitor-agent-service';
import { AgentApi } from './apis/agent-api';

/**
 * Home 模块的 DI 容器配置
 */
export const homeModule = new ContainerModule((bind) => {
    bind(HomeIpApiImpl).toSelf();
    bind(HomeIpApi).toService(HomeIpApiImpl);
    bind(AgentApi).toService(HomeIpApiImpl);
    bind(PlaybookRegistry).to(PlaybookRegistryImpl);
    bind(IpProfileExternalService).to(IpProfileExternalServiceImpl);
    bind(MonitorAgentService).to(MonitorAgentServiceImpl);
});
